import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1, IconChevronRight16, IconChevronLeft16 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ICustomSwiperNavigationRef } from '../../../../components/CustomSwiper';

interface IContainerProps {
  title: string;
  description: string;
  carousel: React.ReactNode;
  navRef: ICustomSwiperNavigationRef;
}

export function StandardLayout({ title, carousel, description, navRef }: IContainerProps) {
  return (
    <section className={styles['container']} id="pik-standard">
      <div className={styles['header']}>
        <ArticleHeading1>{title}</ArticleHeading1>
        <div className={styles['description']}>
          <ArticleParagraph1>{description}</ArticleParagraph1>
        </div>
      </div>
      <div className={styles['carousel']}>
        <button className={`${styles['button']} ${styles['prev']}`} type="button" ref={navRef.prev}>
          <IconChevronLeft16 color="gray_icons_100" />
        </button>
        <button className={`${styles['button']} ${styles['next']}`} type="button" ref={navRef.next}>
          <IconChevronRight16 color="gray_icons_100" />
        </button>
        {carousel}
      </div>
    </section>
  );
}
